<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="card-header text-left fixed-card-title2">
			<v-row no-gutters>
				<v-col class="align-center d-flex" cols="10">
					<v-toolbar-title>{{ $t('edit-condition-history-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon @click="closeDrawer" class="white-icon">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pt-4 pb-0 overflow-y-auto" style="height: calc(100vh - 221px)">
			<v-row dense class="ma-0 pt-2">
				<v-col>
					<v-textarea outlined no-resize rows="10" hide-details v-model="reasonText" :label="$t('reason')" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0 pt-2">
				<v-col class="pb-0">
					<v-select
						:label="$t('event-type')"
						v-model="eventType"
						:items="conditionEventTypeOptionTemplate"
						item-text="code"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ $t(item.code) }}
									</span>
								</template>
								{{ $t(item.description) }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter
						:inputValue="timeSpentSeconds"
						@update:inputValue="(val) => (timeSpentSeconds = val)"
						:inputLabel="$t('time-spent')"
						:dense="false" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip left v-if="!editButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('update') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="updateConditionHistory()" color="dark_purple" style="color: white" block>
						{{ $t('update') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMConditionHistoryEdit',
	components: { InputTimeFormatter },
	data () {
		return {
			eventType: '',
			reasonText: '',
			timeSpentSeconds: 0,
			conditionEventTypeOptionTemplate: null,
		};
	},
	computed: {
		...mapState({
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			currentConditionHistory: (state) => state.ccmConditions.ccmConditionHistory,
		}),
		editButtonEnabled () {
			return this.reasonText.trim() && this.timeSpentSeconds && this.timeSpentSeconds <= 7200;
		},
	},
	methods: {
		...mapActions({
			editCCMConditionHistory: 'ccmConditions/editConditionHistory',
			getConditions: 'ccmConditions/getCCMConditionsByPatientId',
			getConditionEventTypeOption: 'ccmRecords/getConditionEventTypeOption',
		}),
		closeDrawer () {
			this.timeSpentSeconds = 0;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},
		async updateConditionHistory () {
			const request = {
				id: this.currentConditionHistory.id,
				body: {
					eventType: this.eventType,
					reason: this.reasonText,
					conditionHistoryTimestampUTC: this.currentConditionHistory.conditionHistoryTimestampUTC,
					staffId: this.currentConditionHistory.staffId,
					performedBy: this.currentConditionHistory.performedBy,
					performedByRole: this.currentConditionHistory.performedByRole,
					timeSpentSeconds: this.timeSpentSeconds,
					additionalData: this.currentConditionHistory.additionalData,
				},
			};
			await this.editCCMConditionHistory(request);
			this.getConditions(this.currentRecord.patientId);
			this.closeDrawer();
		},
	},
	async mounted () {
		this.reasonText = this.currentConditionHistory.reason;
		this.eventType = this.currentConditionHistory.eventType;
		if (!this.conditionEventTypeOptionTemplate) {
			const response = await this.getConditionEventTypeOption();
			this.conditionEventTypeOptionTemplate = response.data;
		}
	},
	watch: {
		currentConditionHistory () {
			this.reasonText = this.currentConditionHistory.reason;
			this.eventType = this.currentConditionHistory.eventType;
		},
	},
};
</script>
